import React, { Fragment, useEffect } from 'react';
import { useLocation } from 'react-router-dom/';

import { H1, H2, Icon, UtilityHeader, Footer, SideNav, BREAKPOINTS } from '@awesomecomponents/mux';
import styled from 'styled-components';
import { errorContext } from '../utils/appConstants';
import { buildFooterMenus, buildHeaderRight } from '../utils/navigationBuilder';
import ERROR_CODES from '../utils/ErrorCodes';

const HeaderContainer = styled.div`
  position: relative;
`;

const Container = styled.main`
  position: absolute;
  top: 40px;
  left: 100px;
  right: 0;
  bottom: 0;
  overflow: auto;

  @media (max-width: ${BREAKPOINTS.MAX_1600}px) {
    left: 80px;
  }

  @media (max-width: ${BREAKPOINTS.MAX_768}px) {
    top: 60px;
    left: 0;
  }
`;

const Content = styled.div`
  position: relative;
  min-height: calc(100vh - 250px);
  margin: 8%;
`;

const ContentHeader = styled.div`
  position: relative;
  min-height: calc(10px);
  margin: 2%;
`;

const SideNavWrapper = styled.div`
  & nav {
    overflow-y: hidden;
  }
`;

const ErrorPage = ({ type = '', lang = 'en-CA' }) => {
  const location = useLocation();

  // Check any state passed on history push
  const error = location.state?.error;

  // Check if error is a valid error code. Otherwise, undefined.
  const code = Object.keys(ERROR_CODES).some((errorCode) => ERROR_CODES[errorCode] === error) ? error : undefined;

  let context;
  if (type === 'error' && lang === 'en-CA') {
    context = errorContext.errorEn;
  } else if (type === 'error' && lang === 'fr-CA') {
    context = errorContext.errorFr;
  } else {
    context = errorContext.unAuthorized;
  }
  useEffect(() => {
    const currentTitle = document.title;
    document.title = context.pageTitle;
    return () => (document.title = currentTitle);
  }, [context.pageTitle]);
  return (
    <Fragment>
      <HeaderContainer>
        <UtilityHeader
          rightItems={buildHeaderRight(lang)}
          rightMobileItems={buildHeaderRight(lang)}
          showLangToggle={false}
          showSignin={false}
          lang={lang}
          tabIndex={1}
        />
        <SideNavWrapper>
          <SideNav lang={lang} showSignIn={false} showContactUs={false} tabIndex={2} />
        </SideNavWrapper>
      </HeaderContainer>
      <Container id="mainContainer">
        <ContentHeader>
          {' '}
          <H2>
            <b>Manulife</b>
          </H2>{' '}
        </ContentHeader>
        <Content>
          <H1>
            <b>{context.pageTitle}</b>
          </H1>
          <p>{context.headerText}</p>
          <br></br>
          <p>
            <b>{context.bodyText} </b>
            <br></br>
            {code && <b>CODE: {code} </b>}
          </p>
          {context.fineText}{' '}
          {context.anchorText ? (
            <a href="https://www.manulife.ca/personal/support.html">
              {context.anchorText}{' '}
              <Icon
                color="transparent"
                fill="#00C46E"
                manulifeName="external"
                isExternal="true"
                ariaLabel="Manulife Open a new window"
              />{' '}
            </a>
          ) : (
            <p />
          )}
        </Content>
        <Footer items={buildFooterMenus(lang)} lang={lang} tabIndex={40} />
      </Container>
    </Fragment>
  );
};

export default ErrorPage;
